var map = {
	"./Ubisoft-plus-cloud-gaming-devices_desktop.png": 198,
	"./Ubisoft-plus-cloud-gaming-devices_desktop.webp": 32,
	"./Ubisoft-plus-cloud-gaming-devices_mobile.png": 199,
	"./Ubisoft-plus-cloud-gaming-devices_mobile.webp": 33,
	"./Ubisoft-plus-cloud-gaming-devices_tablet.png": 200,
	"./Ubisoft-plus-cloud-gaming-devices_tablet.webp": 34,
	"./Ubisoft-plus-crew-2-gold-edition_desktop.png": 201,
	"./Ubisoft-plus-crew-2-gold-edition_desktop.webp": 35,
	"./Ubisoft-plus-crew-2-gold-edition_mobile.png": 202,
	"./Ubisoft-plus-crew-2-gold-edition_mobile.webp": 36,
	"./Ubisoft-plus-crew-2-gold-edition_tablet.png": 203,
	"./Ubisoft-plus-crew-2-gold-edition_tablet.webp": 37,
	"./Ubisoft-plus-game-library-Ubisoft-Connect_desktop.png": 204,
	"./Ubisoft-plus-game-library-Ubisoft-Connect_desktop.webp": 38,
	"./Ubisoft-plus-game-library-Ubisoft-Connect_mobile.png": 205,
	"./Ubisoft-plus-game-library-Ubisoft-Connect_mobile.webp": 39,
	"./Ubisoft-plus-game-library-Ubisoft-Connect_tablet.png": 206,
	"./Ubisoft-plus-game-library-Ubisoft-Connect_tablet.webp": 40,
	"./Ubisoft-plus-mouse-icon.svg": 207,
	"./Ubisoft-plus-mouse-icon_emea.svg": 208,
	"./Ubisoft-plus-open-lock-icon.svg": 209,
	"./Ubisoft-plus-quality-badge-icon.svg": 210,
	"./Ubisoft-plus-star-icon.svg": 211,
	"./Ubisoft-plus-wings-icon.svg": 212,
	"./Ubisoft-plus-wings-icon_emea.svg": 213,
	"./Uplay+_colours.pdf": 214,
	"./Uplayplus_LP_carousel_ACOD.jpg": 215,
	"./Uplayplus_LP_carousel_ACOD.webp": 41,
	"./Uplayplus_LP_carousel_ACOD_desktop.png": 216,
	"./Uplayplus_LP_carousel_ACOD_desktop.webp": 42,
	"./Uplayplus_LP_carousel_ACOD_mobile.png": 217,
	"./Uplayplus_LP_carousel_ACOD_mobile.webp": 43,
	"./Uplayplus_LP_carousel_ACOD_tablet.png": 218,
	"./Uplayplus_LP_carousel_ACOD_tablet.webp": 44,
	"./Uplayplus_LP_carousel_ACV_desktop.png": 219,
	"./Uplayplus_LP_carousel_ACV_desktop.webp": 45,
	"./Uplayplus_LP_carousel_ACV_mobile.png": 220,
	"./Uplayplus_LP_carousel_ACV_mobile.webp": 46,
	"./Uplayplus_LP_carousel_ACV_tablet.png": 221,
	"./Uplayplus_LP_carousel_ACV_tablet.webp": 47,
	"./Uplayplus_LP_carousel_Anno1800_desktop.png": 222,
	"./Uplayplus_LP_carousel_Anno1800_desktop.webp": 48,
	"./Uplayplus_LP_carousel_Anno1800_mobile.png": 223,
	"./Uplayplus_LP_carousel_Anno1800_mobile.webp": 49,
	"./Uplayplus_LP_carousel_Anno1800_tablet.png": 224,
	"./Uplayplus_LP_carousel_Anno1800_tablet.webp": 50,
	"./Uplayplus_LP_carousel_FC5_desktop.png": 225,
	"./Uplayplus_LP_carousel_FC5_desktop.webp": 51,
	"./Uplayplus_LP_carousel_FC5_mobile.png": 226,
	"./Uplayplus_LP_carousel_FC5_mobile.webp": 52,
	"./Uplayplus_LP_carousel_FC5_tablet.png": 227,
	"./Uplayplus_LP_carousel_FC5_tablet.webp": 53,
	"./Uplayplus_LP_carousel_FCND_desktop.png": 228,
	"./Uplayplus_LP_carousel_FCND_desktop.webp": 54,
	"./Uplayplus_LP_carousel_FCND_mobile.png": 229,
	"./Uplayplus_LP_carousel_FCND_mobile.webp": 55,
	"./Uplayplus_LP_carousel_FCND_tablet.png": 230,
	"./Uplayplus_LP_carousel_FCND_tablet.webp": 56,
	"./Uplayplus_LP_carousel_FH_desktop.png": 231,
	"./Uplayplus_LP_carousel_FH_desktop.webp": 57,
	"./Uplayplus_LP_carousel_FH_mobile.png": 232,
	"./Uplayplus_LP_carousel_FH_mobile.webp": 58,
	"./Uplayplus_LP_carousel_FH_tablet.png": 233,
	"./Uplayplus_LP_carousel_FH_tablet.webp": 59,
	"./Uplayplus_LP_carousel_GRBP_desktop.png": 234,
	"./Uplayplus_LP_carousel_GRBP_desktop.webp": 60,
	"./Uplayplus_LP_carousel_GRBP_mobile.png": 235,
	"./Uplayplus_LP_carousel_GRBP_mobile.webp": 61,
	"./Uplayplus_LP_carousel_GRBP_tablet.png": 236,
	"./Uplayplus_LP_carousel_GRBP_tablet.webp": 62,
	"./Uplayplus_LP_carousel_IFR_desktop.png": 237,
	"./Uplayplus_LP_carousel_IFR_desktop.webp": 63,
	"./Uplayplus_LP_carousel_IFR_mobile.png": 238,
	"./Uplayplus_LP_carousel_IFR_mobile.webp": 64,
	"./Uplayplus_LP_carousel_IFR_tablet.png": 239,
	"./Uplayplus_LP_carousel_IFR_tablet.webp": 65,
	"./Uplayplus_LP_carousel_PoPFS_desktop.png": 240,
	"./Uplayplus_LP_carousel_PoPFS_desktop.webp": 66,
	"./Uplayplus_LP_carousel_PoPFS_mobile.png": 241,
	"./Uplayplus_LP_carousel_PoPFS_mobile.webp": 67,
	"./Uplayplus_LP_carousel_PoPFS_tablet.png": 242,
	"./Uplayplus_LP_carousel_PoPFS_tablet.webp": 68,
	"./Uplayplus_LP_carousel_R6S_desktop.png": 243,
	"./Uplayplus_LP_carousel_R6S_desktop.webp": 69,
	"./Uplayplus_LP_carousel_R6S_mobile.png": 244,
	"./Uplayplus_LP_carousel_R6S_mobile.webp": 70,
	"./Uplayplus_LP_carousel_R6S_tablet.png": 245,
	"./Uplayplus_LP_carousel_R6S_tablet.webp": 71,
	"./Uplayplus_LP_carousel_SCblacklist_desktop.png": 246,
	"./Uplayplus_LP_carousel_SCblacklist_desktop.webp": 72,
	"./Uplayplus_LP_carousel_SCblacklist_mobile.png": 247,
	"./Uplayplus_LP_carousel_SCblacklist_mobile.webp": 73,
	"./Uplayplus_LP_carousel_SCblacklist_tablet.png": 248,
	"./Uplayplus_LP_carousel_SCblacklist_tablet.webp": 74,
	"./Uplayplus_LP_carousel_TC2_desktop.png": 249,
	"./Uplayplus_LP_carousel_TC2_desktop.webp": 75,
	"./Uplayplus_LP_carousel_TC2_mobile.png": 250,
	"./Uplayplus_LP_carousel_TC2_mobile.webp": 76,
	"./Uplayplus_LP_carousel_TC2_tablet.png": 251,
	"./Uplayplus_LP_carousel_TC2_tablet.webp": 77,
	"./Uplayplus_LP_carousel_TCTD2_desktop.png": 252,
	"./Uplayplus_LP_carousel_TCTD2_desktop.webp": 78,
	"./Uplayplus_LP_carousel_TCTD2_mobile.png": 253,
	"./Uplayplus_LP_carousel_TCTD2_mobile.webp": 79,
	"./Uplayplus_LP_carousel_TCTD2_tablet.png": 254,
	"./Uplayplus_LP_carousel_TCTD2_tablet.webp": 80,
	"./Uplayplus_LP_carousel_TrialsRising_desktop.png": 255,
	"./Uplayplus_LP_carousel_TrialsRising_desktop.webp": 81,
	"./Uplayplus_LP_carousel_TrialsRising_mobile.png": 256,
	"./Uplayplus_LP_carousel_TrialsRising_mobile.webp": 82,
	"./Uplayplus_LP_carousel_TrialsRising_tablet.png": 257,
	"./Uplayplus_LP_carousel_TrialsRising_tablet.webp": 83,
	"./Uplayplus_LP_carousel_WDL.jpg": 258,
	"./Uplayplus_LP_carousel_WDL_desktop.png": 259,
	"./Uplayplus_LP_carousel_WDL_desktop.webp": 84,
	"./Uplayplus_LP_carousel_WDL_mobile.png": 260,
	"./Uplayplus_LP_carousel_WDL_mobile.webp": 85,
	"./Uplayplus_LP_carousel_WDL_tablet.png": 261,
	"./Uplayplus_LP_carousel_WDL_tablet.webp": 86,
	"./acv_slide_desktop.jpg": 262,
	"./acv_slide_desktop.webp": 87,
	"./acv_slide_mobile.jpg": 263,
	"./acv_slide_mobile.webp": 88,
	"./acv_slide_tablet.jpg": 264,
	"./acv_slide_tablet.webp": 89,
	"./banners_logo_luna.png": 265,
	"./banners_logo_luna.webp": 90,
	"./banners_logo_stadia.png": 266,
	"./banners_logo_stadia.webp": 91,
	"./caretSvg.svg": 267,
	"./clockIcon.svg": 268,
	"./diamond-icon.svg": 269,
	"./fc6_slide_desktop.jpg": 270,
	"./fc6_slide_desktop.webp": 92,
	"./fc6_slide_logo.png": 271,
	"./fc6_slide_logo.webp": 93,
	"./fc6_slide_mobile.jpg": 272,
	"./fc6_slide_mobile.webp": 94,
	"./fc6_slide_tablet.jpg": 273,
	"./fc6_slide_tablet.webp": 95,
	"./games-icon.svg": 274,
	"./gm_slide_desktop.jpg": 275,
	"./gm_slide_desktop.webp": 96,
	"./gm_slide_mobile.jpg": 276,
	"./gm_slide_mobile.webp": 97,
	"./gm_slide_tablet.jpg": 277,
	"./gm_slide_tablet.webp": 98,
	"./mad_slide_desktop.jpg": 278,
	"./mad_slide_desktop.webp": 99,
	"./mad_slide_mobile.jpg": 279,
	"./mad_slide_mobile.webp": 100,
	"./mad_slide_tablet.jpg": 280,
	"./mad_slide_tablet.webp": 101,
	"./old_banners_assets/Ubisoft-plus-cloud-gaming-devices.png": 281,
	"./old_banners_assets/Ubisoft-plus-cloud-gaming-devices.webp": 102,
	"./old_banners_assets/Ubisoft-plus-crew-2-gold-edition.png": 282,
	"./old_banners_assets/Ubisoft-plus-crew-2-gold-edition.webp": 103,
	"./old_banners_assets/Ubisoft-plus-game-library-Ubisoft-Connect.png": 283,
	"./old_banners_assets/Ubisoft-plus-game-library-Ubisoft-Connect.webp": 104,
	"./old_banners_assets/fc6_slide_desktop.jpg": 284,
	"./old_banners_assets/fc6_slide_mobile.jpg": 285,
	"./old_banners_assets/fc6_slide_tablet.jpg": 286,
	"./old_banners_assets/mad_slide_desktop.jpg": 287,
	"./old_banners_assets/mad_slide_mobile.jpg": 288,
	"./old_banners_assets/mad_slide_tablet.jpg": 289,
	"./play-button.svg": 290,
	"./pps_slide_desktop.jpg": 291,
	"./pps_slide_desktop.webp": 105,
	"./pps_slide_mobile.jpg": 292,
	"./pps_slide_mobile.webp": 106,
	"./pps_slide_tablet.jpg": 293,
	"./pps_slide_tablet.webp": 107,
	"./rainbow_six_slide_desktop.jpg": 294,
	"./rainbow_six_slide_desktop.webp": 108,
	"./rainbow_six_slide_mobile.jpg": 295,
	"./rainbow_six_slide_mobile.webp": 109,
	"./rainbow_six_slide_ru_desktop.jpg": 296,
	"./rainbow_six_slide_ru_desktop.webp": 110,
	"./rainbow_six_slide_ru_mobile.jpg": 297,
	"./rainbow_six_slide_ru_mobile.webp": 111,
	"./rainbow_six_slide_ru_tablet.jpg": 298,
	"./rainbow_six_slide_ru_tablet.webp": 112,
	"./rainbow_six_slide_tablet.jpg": 299,
	"./rainbow_six_slide_tablet.webp": 113,
	"./replay-icon.svg": 300,
	"./reward-icon.svg": 301,
	"./slidernav_left.svg": 302,
	"./slidernav_right.svg": 303,
	"./sp_slide_desktop.jpg": 304,
	"./sp_slide_desktop.webp": 114,
	"./sp_slide_mobile.jpg": 305,
	"./sp_slide_mobile.webp": 115,
	"./sp_slide_tablet.jpg": 306,
	"./sp_slide_tablet.webp": 116,
	"./ubisoft-plus_hero_desktop.jpg": 12,
	"./ubisoft-plus_hero_large_desktop.jpg": 15,
	"./ubisoft-plus_hero_mobile.jpg": 16,
	"./ubisoft-plus_rewards_program_desktop.png": 307,
	"./ubisoft-plus_rewards_program_desktop.webp": 117,
	"./ubisoft-plus_rewards_program_mobile.png": 308,
	"./ubisoft-plus_rewards_program_mobile.webp": 118,
	"./ubisoft-plus_rewards_program_tablet.png": 309,
	"./ubisoft-plus_rewards_program_tablet.webp": 119,
	"./ubisoft_plus_logo.svg": 30,
	"./ubisoft_plus_slide_desktop.jpg": 310,
	"./ubisoft_plus_slide_desktop.webp": 120,
	"./ubisoft_plus_slide_mobile.jpg": 311,
	"./ubisoft_plus_slide_mobile.webp": 121,
	"./ubisoft_plus_slide_tablet.jpg": 312,
	"./ubisoft_plus_slide_tablet.webp": 122,
	"./uplayplus-ico-download.svg": 313,
	"./uplayplus-ico-earlyaccess.svg": 314,
	"./uplayplus-ico-newreleases.svg": 315,
	"./uplayplus-ico-playtrailer.svg": 316,
	"./uplayplus-ico-plus.svg": 317,
	"./uplayplus-ico-premium.svg": 318,
	"./uplayplus-logo-whtblue.svg": 319,
	"./valhala_fenyx_rysing_background_desktop.jpg": 320,
	"./valhala_fenyx_rysing_background_desktop.webp": 123,
	"./valhala_fenyx_rysing_background_mobile.jpg": 321,
	"./valhala_fenyx_rysing_background_mobile.webp": 124,
	"./valhala_fenyx_rysing_background_tablet.jpg": 322,
	"./valhala_fenyx_rysing_background_tablet.webp": 125,
	"./wdl_logo.png": 323,
	"./wdl_logo.webp": 126,
	"./wdl_slide_desktop.jpg": 324,
	"./wdl_slide_desktop.webp": 127,
	"./wdl_slide_mobile.jpg": 325,
	"./wdl_slide_mobile.webp": 128,
	"./wdl_slide_tablet.jpg": 326,
	"./wdl_slide_tablet.webp": 129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13;